export function getExtensionForMimeType(mimeType?: string): string {
  switch (mimeType) {
    case 'image/png':
      return '.png';
    case 'image/webp':
      return '.webp';
    case 'image/heic':
      return '.heic';
    case 'image/heif':
      return '.heif';
    case 'image/gif':
      return '.gif';
    case 'image/jpeg':
    case 'image/jpg':
    default:
      return '.jpg';
  }
}
